module.exports = __webpack_public_path__ + "img/shin1.eee46dee.jpg";